const ADMIN_BASE = "/api/admin";

export class AdminApiError extends Error {
  constructor(message, status) {
    super(message);
    this.name = "AdminApiError";
    this.status = status;
  }
}

async function adminRequest(path, adminKey, options = {}) {
  const response = await fetch(`${ADMIN_BASE}${path}`, {
    ...options,
    headers: {
      ...(options.body ? { "Content-Type": "application/json" } : {}),
      "X-API-Key": adminKey,
      ...options.headers,
    },
  });

  const text = await response.text();
  let payload = {};
  if (text) {
    try {
      payload = JSON.parse(text);
    } catch (_error) {
      payload = { error: "The server returned an unreadable response." };
    }
  }

  if (!response.ok) {
    throw new AdminApiError(
      payload.error || `Admin request failed with status ${response.status}.`,
      response.status
    );
  }
  return payload;
}

export function validateAdminKey(adminKey) {
  return adminRequest("/validate", adminKey);
}

export function listEntitlements(adminKey, filters) {
  const params = new URLSearchParams({
    page: String(filters.page),
    pageSize: String(filters.pageSize),
    status: filters.status,
    sort: filters.sort,
    direction: filters.direction,
  });
  if (filters.query) params.set("q", filters.query);
  return adminRequest(`/entitlements-page?${params.toString()}`, adminKey);
}

export function createEntitlement(adminKey, { apiKey, quota }) {
  return adminRequest("/entitlements", adminKey, {
    method: "POST",
    body: JSON.stringify({ apiKey, quota }),
  });
}

export function addEntitlementQuota(adminKey, apiKey, addQuota) {
  return adminRequest(
    `/entitlements/${encodeURIComponent(apiKey)}/add-quota`,
    adminKey,
    { method: "POST", body: JSON.stringify({ addQuota }) }
  );
}

export function deleteEntitlement(adminKey, apiKey) {
  return adminRequest(`/entitlements/${encodeURIComponent(apiKey)}`, adminKey, {
    method: "DELETE",
  });
}
